module.exports = __webpack_public_path__ + "media/src/images/icon__whatsapp-321e2f202e8247c37cd730f38974bd03.png";